"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var get_1 = __importDefault(require("lodash/fp/get"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var FilteredTable_1 = __importDefault(require("containers/TableMaker/FilteredTable"));
var hooks_1 = require("utils/hooks");
var ExportAgreements_1 = __importDefault(require("./ExportAgreements"));
var tableConf_1 = require("./tableConf");
var utils_1 = require("./utils");
var Table = (0, FilteredTable_1.default)(tableConf_1.customerAgreementsTableConf, [utils_1.statusGroupDef, utils_1.discountSplitGroupDef], [(0, get_1.default)('name'), (0, get_1.default)('primaryContactName'), (0, get_1.default)('primaryContactEmail'), end2end_1.getCustomerExtendedAgreementStatus]);
var AgreementsListPage = function () {
    var rechCustomerIdFilter = (0, hooks_1.useQParam)('filter[id]');
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Recharges - Agreements", description: "Recharges - Agreements" }), (0, jsx_runtime_1.jsx)(Table, { width: 1100, toolbarProps: { width: 1072 }, filterFunction: function (items) { return rechCustomerIdFilter ? items === null || items === void 0 ? void 0 : items.filter(function (item) { return item.id === rechCustomerIdFilter; }) : items; }, toolbarContent: {
                    post: (0, jsx_runtime_1.jsx)(ExportAgreements_1.default, {}),
                } })] }));
};
exports.default = AgreementsListPage;
